import { consumeLoginRedirect } from '@utils/loginRedirect';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Restores the page the user requested before being sent to the Ory login flow.
 *
 * Ory's Account Experience UI blanks `return_to` before the login flow is created, so the
 * deep link cannot travel through the URL. `logout()` stashes it in sessionStorage instead
 * and this hook consumes it on the first authenticated render after the round-trip.
 */
export const useLoginRedirectRestore = (isAuthenticated: boolean): void => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!isAuthenticated) {
			return;
		}

		const target = consumeLoginRedirect();
		if (target) {
			navigate(target, { replace: true });
		}
	}, [isAuthenticated, navigate]);
};
